import { getTemplate } from "../template-helper";
import Inputmask from "inputmask";
import { locale } from "../../util/locales" ;

const COMPONENT_NAME = "z-number" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

function escapeRegExp(str) {
    return str.replace(/[|\\{}()[\]^$+*?.-]/g, "\\$&");
}

function replaceAll(str, find, replace) {
    return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
} 

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class NumberComponent extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback(){
                this.init() ;
            }

            init(){
                if(!this.innerHTML){
                    const clone = document.importNode(template.content, true);
                    this.appendChild(clone);
                }

                let input = this.querySelector("input") ;

                let maskOptions = { 
                    alias: "currency",
                    placeholder: "",
                    digitsOptional: true,
                    inputmode: "numeric",
                    radixPoint: locale.number.delimiters.decimal , 
                    groupSeparator : locale.number.delimiters.thousands , 
                    prefix : "", suffix : "", positionCaretOnTab: false
                };

                if(/SAMSUNG|SGH-[A-Z]|GT-[A-Z]|SM-[A-Z]|SHV-E|SCH-[A-Z]|SPH-L/i.test(navigator.userAgent) || /iPad|iPhone|iPod/.test(navigator.userAgent)){
                    //samsung does not have comma in numpad
                    maskOptions.inputmode = "text";
                }
                
                const decimaldigits = this.getAttribute("z-decimaldigits") ;
                const fieldType = this.getAttribute("z-type") ;
          
                if(decimaldigits){
                    const digits = Number(decimaldigits) ;
                    if(isNaN(digits)){
                        throw "Invalid value for option decimaldigits, number expected" ;		
                    }
                    maskOptions.digits = digits ;
                }
          
                let type = "text" ;
                
                if(fieldType === "int" || fieldType === "integer" || fieldType==="number" || fieldType==="percentint") {
                    if(fieldType === "percentint"){
                        maskOptions.suffix = " %";
                    }
                    maskOptions.digits = 0 ;
                }else if(fieldType ==="numeric" || fieldType==="decimal" || fieldType==="double" || fieldType==="float"  || fieldType==="percent"  || fieldType==="currency"){
                    if(fieldType === "percent"){
                        maskOptions.suffix = " %";
                    }else if(fieldType === "double"){
                        maskOptions.digits = this.getAttribute("z-decimaldigits")||this.getAttribute("size") || 2 ;
                    }
                }
                this.maskOptions = maskOptions ;

                const im = new Inputmask(maskOptions);
                

                input.type = type;
                im.mask(input) ;
                input.inputmask.shadowRoot = input.getRootNode() ;
                
                this.input = input ;
                this.currentValue = null ;
                if(this.customValidity){
                    this.setCustomValidity(this.customValidity) ;
                }
                this.applyReadonly() ;
                this.applyRequired() ;
                this.applyPlaceholder() ;

                input.addEventListener("focus", function(){
                    input.select() ;
                }) ;
            }

            get value() {
                if(!this.input){ return null ; }
                let value = this.input.inputmask.unmaskedvalue() ;
                if(this.maskOptions){
                    if(this.maskOptions.groupSeparator === "."){
                        //the dot is group separator, eliminate it first to avoid removing the decimal dot
                        value = replaceAll(value, this.maskOptions.groupSeparator, "");
                    }
                    value = replaceAll(value, this.maskOptions.radixPoint, ".");
                    if(this.maskOptions.groupSeparator !== "."){
                        value = replaceAll(value, this.maskOptions.groupSeparator, "");
                    }
                    value = replaceAll(value, this.maskOptions.prefix, "");
                    value = replaceAll(value,this.maskOptions.suffix, "");
                }
                if(value === ""){
                    return null;
                }
                return Number(value) ;
            }
            
            set value(value) {
                if(!this.input){
                    this.init() ;
                }
                if(value){
                    value = (""+value)
                        .replace(new RegExp(this.maskOptions.radixPoint.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1"), 'g'), ".")
                        .replace(new RegExp(this.maskOptions.groupSeparator.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1"), 'g'), "")
                        .replace(new RegExp(this.maskOptions.prefix.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1"), 'g'), "")
                        .replace(new RegExp(this.maskOptions.suffix.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1"), 'g'), "") ;
                    value = value.replace(/[^\-.0-9]/g, "") ;
                    value = (value === "" || value === ".") ? null : Number(value);
                    if(value && (this.fieldType === "percent" || this.fieldType === "percentint")){
                        value = value/100 ;
                    }
                }
                this.currentValue = value;
                let strValue = ""+value ;
                if(this.maskOptions.digits){
                    if(!value){
                        strValue = Number(0).toFixed(this.maskOptions.digits);
                    }else{
                        strValue = value.toFixed(this.maskOptions.digits);
                    }
                }
                strValue = strValue.replace(".", this.maskOptions.radixPoint);
                this.input.value = strValue ;
                if(this.getAttribute("value") !== ""+this.currentValue){
                    this.setAttribute('value', this.currentValue);
                    //this.dispatchEvent(new Event('change', {bubbles: true}));
                }
            }

            select(){
                if(this.input && this.input.select){
                    this.input.select() ;
                }
            }
            focus(){
                if(this.input && this.input.focus){
                    this.input.focus() ;
                }
            }
            checkValidity(){
                if(this.input && this.input.checkValidity){
                    return this.input.checkValidity() ;
                }
                return true;
            }
            setCustomValidity(msg){
                this.customValidity = msg ;
                if(this.input){
                    this.input.setCustomValidity(msg) ;
                }
            }

            static get observedAttributes() {
                return ['readonly', 'required', 'placeholder'];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'readonly':
                        this.applyReadonly();
                        break;
                    case 'required':
                        this.applyRequired();
                        break;
                    case 'placeholder':
                        this.applyPlaceholder();
                        break;
                }
            }

            applyReadonly(){
                const readonly = this.hasAttribute("readonly") ;

                const input = this.querySelector("input") ;
                const button = this.querySelector("button") ;
                if(input){
                    input.readOnly = readonly ;
                }
                if(button){
                    button.disabled = readonly ;
                }
            }
    
            applyRequired(){
                const required = this.hasAttribute("required") ;

                const input = this.querySelector("input") ;
                if(input){
                    if(required){
                        input.setAttribute("required", "required") ;
                    }else{
                        input.removeAttribute("required") ;
                    }
                }
            }
            applyPlaceholder(){
                if(this.input){
                    if(this.hasAttribute("placeholder")){
                        this.input.setAttribute("placeholder", this.getAttribute("placeholder")) ;
                    }else{
                        this.input.removeAttribute("placeholder") ;
                    }
                }
            }
        }
        customElements.define(COMPONENT_NAME, NumberComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
